import alias from '@/locales/alias.yaml'
import aliasLocale from '@/locales/elementAlias.yaml'
import ru from '@/locales/ru.yaml'
import sr from '@/locales/sr.yaml'
import en from '@/locales/en.yaml'
import Vue from 'vue'
import VueI18n from 'vue-i18n'
// @ts-ignore
import ElementLocale from 'element-ui/lib/locale'
// @ts-ignore
import ruLocale from 'element-ui/lib/locale/lang/ru-RU'
// @ts-ignore
import srLocale from 'element-ui/lib/locale/lang/sr-Latn'
// @ts-ignore
import enLocale from 'element-ui/lib/locale/lang/en'

Vue.use(VueI18n)

const messages = {
  alias: {
    ...alias,
    ...aliasLocale,
  },
  en: {
    ...en,
    ...enLocale,
  },
  ru: {
    ...ru,
    ...ruLocale,
  },
  sr: {
    ...sr,
    ...srLocale,
  },
}

export const i18n = new VueI18n({
  locale: 'ru',
  fallbackLocale: 'ru',
  messages,
})

ElementLocale.i18n((key: string, value: string) => i18n.t(key, value))
